import React from 'react'
import './spinnerCertificate.sass'

const SpinnerCertificate = () => {
    return (
        <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}

export default SpinnerCertificate
